<script lang="ts">
  import { meetingStore } from '../stores/meetingStore';
  import type { Currency } from '../stores/meetingStore';
  import { _ } from 'svelte-i18n';
  import { IconChevronDown, IconCurrencyDollar } from '@tabler/icons-svelte';
  
  const currencies: Currency[] = ['EUR', 'USD', 'GBP', 'JPY', 'CHF', 'CAD', 'AUD'];
  
  let currentCurrency: Currency = 'EUR';
  let isUpdating = false;
  const selectId = `currency-select-${Math.random().toString(36).substr(2, 9)}`;
  
  meetingStore.subscribe((state) => {
    if (!isUpdating) {
      currentCurrency = state.currency;
    }
  });
  
  function handleChange() {
    isUpdating = true;
    meetingStore.updateCurrency(currentCurrency);
    isUpdating = false;
  }
</script>

<div class="flex flex-col gap-2">
  <label for={selectId} class="text-sm font-medium text-custom-heading dark:text-white/90 flex items-center gap-2">
    <IconCurrencyDollar class="w-4 h-4 icon-accent" />
    {$_(`calculator.currency`)}
  </label>
  <div class="relative">
    <select
      id={selectId}
      bind:value={currentCurrency}
      on:change={handleChange}
      class="glass-input w-full px-4 py-3 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/50 dark:focus:ring-blue-400/50 focus:border-blue-500/50 dark:focus:border-blue-400/50 focus-accent transition-all appearance-none cursor-pointer"
    >
      {#each currencies as currency}
        <option value={currency} class="bg-white dark:bg-slate-800 text-custom dark:text-white">
          {currency} - {$_(`currencies.${currency}`)}
        </option>
      {/each}
    </select>
    <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
      <IconChevronDown class="w-5 h-5 text-custom dark:text-white" />
    </div>
  </div>
</div>
